export * from './ProductCardV2LabelContainer';
